<template>
  <div class="surrender-register">
    <div class="title">请填写您在爱民保投保的订单信息，必须一致</div>
    <van-form ref="appntForm">
      <van-cell-group inset>
        <van-field
          v-for="(field, index) in formData.fieldList"
          :key="index"
          v-model="formData.data[field.value]"
          label-width="120"
          :name="field.label"
          :label="field.label"
          :placeholder="field.placeholder"
          :rules="field.rules"
        />
      </van-cell-group>
    </van-form>
    <div class="title">被保人信息（最多添加三个）</div>
    <van-form ref="insForm">
      <van-cell-group
        class="insList"
        inset
        v-for="(item, i) in insuredPersonList"
        :key="i"
      >
        <div>
          <van-field
            v-for="(field, index) in item.insList"
            :key="index"
            v-model="item.data[field.value]"
            label-width="124"
            :name="`被保人${i + 1}${field.label}`"
            :label="`被保人${i + 1}${field.label}`"
            :placeholder="field.placeholder"
            :rules="field.rules"
          />
        </div>
        <van-icon name="close" v-if="i > 0" @click="delIns(i)" />
      </van-cell-group>
      <div class="addInsBtn" @click="addIns">添加被保人</div>
    </van-form>
    <!-- <div class="title">将退款到该银行账号，务必填写正确有效的信息</div>
    <van-form ref="bankForm">
      <van-cell-group inset>
        <van-field
          v-for="(field, index) in bankInfo.list"
          :key="index"
          v-model="bankInfo.data[field.value]"
          label-width="120"
          :name="field.label"
          :label="field.label"
          :placeholder="field.placeholder"
          :rules="field.rules"
        />
      </van-cell-group>
    </van-form> -->
    <div class="nextBtn" @click="submit"><span>下一步</span></div>
    <van-dialog
      v-model="show"
      title=""
      show-cancel-button
      confirmButtonText="完成"
      :before-close="sureClick"
    >
      <div>
        请输入投保人手机号{{
          mobilePhone(formData.data.appntMobileNumber)
        }}验证码
      </div>
      <van-field
        v-model="captcha"
        center
        clearable
        maxlength="6"
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button
            size="small"
            round
            type="info"
            :disabled="disabled"
            @click="sendCode"
            >{{ btnText }}</van-button
          >
        </template>
      </van-field>
    </van-dialog>
  </div>
</template>
<script>
  import { CHECK_ID, CHECK_MOBILE_PHONE } from '@/util/validate'
  import { GetVerificationCode } from '@/api/user'
  import { insureCancelApply } from '@/api/surrender'
  export default {
    data() {
      return {
        show: false,
        captcha: '',
        btnText: '发送验证码',
        disabled: false,
        formData: {
          data: {
            appntName: '',
            appntIdNo: '',
            appntMobileNumber: ''
          },
          fieldList: [
            {
              value: 'appntName',
              label: '投保人姓名：',
              placeholder: '请输入投保人姓名',
              rules: [{ required: true, message: '请填写投保人姓名' }]
            },
            {
              value: 'appntIdNo',
              label: '投保人身份证号：',
              placeholder: '请输入投保人身份证号',
              rules: [
                { required: true, message: '请填写投保人身份证号' },
                {
                  required: true,
                  validator: CHECK_ID,
                  message: '证件号格式不正确',
                  trigger: 'onBlur'
                }
              ]
            },
            {
              value: 'appntMobileNumber',
              label: '投保人手机号：',
              placeholder: '请输入投保人手机号',
              rules: [
                { required: true, message: '请填写投保人手机号' },
                {
                  required: true,
                  validator: CHECK_MOBILE_PHONE,
                  message: '手机号格式不正确',
                  trigger: 'onBlur'
                }
              ]
            }
          ]
        },
        insuredPersonList: [
          {
            data: {
              insuredPersonIdNo: '',
              insuredPersonName: ''
            },
            insList: [
              {
                value: 'insuredPersonName',
                label: '姓名：',
                placeholder: '请输入被保人姓名',
                rules: [{ required: true, message: '请填写被保人姓名' }]
              },
              {
                value: 'insuredPersonIdNo',
                label: '身份证号：',
                placeholder: '请输入被保人身份证号',
                rules: [
                  { required: true, message: '请填写被保人身份证号' },
                  {
                    required: true,
                    validator: CHECK_ID,
                    message: '证件号格式不正确',
                    trigger: 'onBlur'
                  }
                ]
              }
            ]
          }
        ],
        insInfo: {
          data: {
            insuredPersonIdNo: '',
            insuredPersonName: ''
          },
          insList: [
            {
              value: 'insuredPersonName',
              label: '姓名：',
              placeholder: '请输入被保人姓名',
              rules: [{ required: true, message: '请填写被保人姓名' }]
            },
            {
              value: 'insuredPersonIdNo',
              label: '身份证号：',
              placeholder: '请输入被保人身份证号',
              rules: [
                { required: true, message: '请填写被保人身份证号' },
                {
                  required: true,
                  validator: CHECK_ID,
                  message: '证件号格式不正确',
                  trigger: 'onBlur'
                }
              ]
            }
          ]
        },
        bankInfo: {
          data: {
            payeeName: '',
            bankName: '',
            bankAccNo: ''
          },
          list: [
            {
              value: 'payeeName',
              label: '收款人姓名：',
              placeholder: '请输入收款人姓名',
              rules: [{ required: true, message: '请填写收款人姓名' }]
            },
            {
              value: 'bankAccNo',
              label: '收款银行账户：',
              placeholder: '请输入收款银行账户',
              rules: [{ required: true, message: '请填写收款银行账户' }]
            },
            {
              value: 'bankName',
              label: '收款开户行：',
              placeholder: '请输入收款开户行',
              rules: [{ required: true, message: '请填写收款开户行' }]
            }
          ]
        }
      }
    },
    created() {
      // 关闭退保
      this.$router.replace({ path: '/404', query: { status: 'D' } })
    },
    methods: {
      addIns() {
        if (this.insuredPersonList.length < 3) {
          this.insuredPersonList.push(JSON.parse(JSON.stringify(this.insInfo)))
        } else {
          this.$toast('最多添加三个被保人')
        }
      },
      delIns(v) {
        this.insuredPersonList.splice(v, 1)
      },
      submit() {
        let that = this
        let p = ['appntForm', 'insForm'].map(item => {
          return that.$refs[item].validate()
        })
        Promise.all(p)
          .then(() => {
            this.show = true
          })
          .catch(() => {
            this.$notify({ type: 'danger', message: '请正确的填写表单信息' })
          })
      },
      sureClick(action, done) {
        if (action === 'cancel') {
          done()
        } else {
          if (!this.captcha) {
            this.$toast('验证码不能为空')
            done(false)
          } else {
            this.insureCancelApply(done)
          }
        }
      },
      mobilePhone(v) {
        let pat = (pat = /(\d{3})\d*(\d{4})/)
        return v.replace(pat, '$1****$2')
      },
      async sendCode() {
        this.disabled = true
        let time = 120
        let that = this
        let timer = setInterval(() => {
          that.btnText = time + 's后重新发送'
          time--
          if (time === 0) {
            clearInterval(timer)
            that.btnText = '发送验证码'
            that.disabled = false
          }
        }, 1000)
        try {
          await GetVerificationCode({
            mobilePhone: this.formData.data.appntMobileNumber
          })
        } catch (e) {
          console.log(e)
        }
      },
      async insureCancelApply(done) {
        let insuredPersonList = this.insuredPersonList.map(item => {
          return item.data
        })
        let data = {
          ...this.formData.data,
          ...this.bankInfo.data,
          insuredPersonList,
          captcha: this.captcha
        }
        try {
          await insureCancelApply(data)
          for (let key in this.formData.data) {
            this.formData.data[key] = ''
          }
          for (let key in this.bankInfo.data) {
            this.bankInfo.data[key] = ''
          }
          this.insuredPersonList.map(item => {
            for (let key in item.data) {
              item.data[key] = ''
            }
          })
          done()
          this.$router.push({ name: 'SurrenderSuccess' })
        } catch (e) {
          done(false)
          this.$toast(e.message)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .surrender-register {
    padding-bottom: xvw(130);
    .title {
      font-size: xvw(30);
      padding: xvw(20) 0 xvw(20) xvw(32);
      font-weight: 600;
    }
    .addInsBtn {
      background: #1989fa;
      color: #ffffff;
      width: xvw(300);
      height: xvw(60);
      border-radius: xvw(30);
      text-align: center;
      line-height: xvw(60);
      margin: xvw(20) auto 0;
      font-size: xvw(30);
    }
    .insList {
      display: flex;
      align-items: center;
    }
    .nextBtn {
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      background: #1989fa;
      width: 100%;
      height: xvw(120);
      line-height: xvw(120);
      span {
        color: #ffffff;
        font-size: xvw(30);
      }
    }
    /deep/.van-dialog {
      .van-dialog__content {
        text-align: center;
        padding: xvw(50) 0 0;
      }
    }
  }
</style>
